import { Img } from "./Img.styles";

export default Img;
